module.exports = __webpack_public_path__ + "img/2.d1004f52.webp";